export const parseError = (error) => {
    let msg = error.error ?? error.Error;
    if (msg == null && error.errors != null) {
        const keys = Object.keys(error.errors);
        if (keys.length > 0)
            msg = error.errors[keys[0]];
    }
    return msg;
}